import axios from "axios";

class FindCep {
  getAddress(zipCode, callback) {
    const request = {
      url: 'https://viacep.com.br/ws/'+zipCode+'/json/',
      method : "GET"
    };
    return axios.create().request(request)
      .then(resp => {
        callback({
          address_city : resp.data.localidade,
          address_neighborhood : resp.data.bairro,
          address_street : resp.data.logradouro,
          address_state : resp.data.uf
        });
      })
      .catch(error => {
        callback(null);
      });
  }
}


const findCep = new FindCep();

export default findCep;